import { useState } from "react";
import DashboardLayout from "../components/DashboardLayout";
import ComingSoon from "../components/bc_pnp/ComingSoon";


export default function Dashboard() {
  
  return (
    <DashboardLayout>
  
      <ComingSoon />
    
    </DashboardLayout>

  );
}
